export const isContactUs = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  const contactUs = searchParams.get('cancelAccount');

  return contactUs === 'true' || false;
};

export const contactUsCheckRedirection = (
  isFinalStepModal: boolean,
  brandName: string
) => {
  const contactUsCheck = isContactUs();

  if (contactUsCheck) {
    const contactUsList = ['neighborwho', 'ownerly', 'peoplesmart'];
    const contactPage = contactUsList.includes(brandName)
      ? 'contact-us'
      : 'contact';

    window.location.href = `https://${brandName}.com/${contactPage}/`;
  } else if (isFinalStepModal) {
    return false;
  }
};
